import React from 'react';
import moment from 'moment';

export default class TextHelpers {

    static formatInstructorName(instructor) {
        const name = TextHelpers.formatName(instructor.firstName, instructor.lastName); 
        return name;
        //if (plainText) {
        //    return name + ' ' + (instructor.isPriority ? '⭐' : '') + ' ' + (instructor.isAvailableILT ? '🏢' : '');
        //} else {
        //    return (<>
        //        {name}
        //    </>); 
        //}
    }

    static getInstructorTags(instructor) {
        return (<>
            {instructor.activeStatus == 'Deactivated' &&
                <span className="tag deactivated">
                    <span className="tag-icon fa-solid fa-skull-crossbones" />
                    <span className="tag-text">Deactivated</span>
                </span>
            }
            {instructor.activeStatus == 'Suspended' &&
                <span className="tag suspended">
                    <span className="tag-icon fa-solid fa-bed" />
                    <span className="tag-text">Suspended</span>
                </span>
            }
            {instructor.isPriority &&
                <span className="tag priority-instructor">
                    <span className="tag-icon fa-solid fa-star" />
                    <span className="tag-text">Priority</span>
                </span>
            }
            {instructor.isAvailableILT &&
                <span className="tag available-ilt">
                    <span className="tag-icon fa-solid fa-building-user" />
                    <span className="tag-text">Available ILT</span>
                </span>
            }
        </>); 
    }

    static formatName(firstName, lastName) {
        const nameParts = [firstName, lastName]
            .filter(np => !!((np || '').trim()))
            .map(n => n.replace('>', '&gt;').replace('<', '&lt;'));
        return nameParts.join(' ');
    }
   
    static simplifySearchString(str) {
        str = (str || '').toLowerCase();
        str = str.normalize('NFD').replace(/\p{Diacritic}/gu, '');
        return str.replace(/[^a-z0-9 -'&@]/, '').trim();
    }

    static formatPercentage(percentage, numDP) {
        if (typeof (numDP) == 'undefined') {
            numDP = 2;
        }
        const div = Math.pow(10, numDP);
        let value = Math.round(percentage * 100 * div) / div;
        return value;
    }

    static formatDateDiff(currentDate, otherDate) {
        currentDate = moment(moment(currentDate).format('YYYY-MM-DD'));
        otherDate = moment(otherDate);
        const diff = Math.ceil(otherDate.diff(currentDate, 'days'));

        // Past
        if (diff <= -7) {
            const numWeeks = Math.floor(Math.abs(diff) / 7);
            return numWeeks + ' week' + (numWeeks == 1 ? '' : 's') + ' ago';
        } else if (diff < -1) {
            return (-diff) + ' days ago';
        } else if (diff == -1) {
            return 'Yesterday';
        }

        // Present
        else if (diff == 0) {
            return 'Today';
        }

        // Future
        else if (diff >= 7) {
            const numWeeks = Math.floor(Math.abs(diff) / 7);
            return 'In ' + numWeeks + ' week' + (numWeeks == 1 ? '' : 's');
        } else if (diff > 1) {
            return 'In ' + diff + ' days';
        } else if (diff == 1) {
            return 'Tomorrow';
        }

        return '';
    }

    static splitName(name, titleCase) {
        const nameParts = name.split(/\s+/);
        const result = {};
        if (nameParts.length == 1) {
            result.firstName = nameParts[0];
        } else if (nameParts.length > 1) {
            result.firstName = nameParts.slice(0, nameParts.length - 1).join(' ');
            result.lastName = nameParts[nameParts.length - 1];
        }
        if (titleCase) {
            if (result.firstName) {
                result.firstName = result.firstName[0].toUpperCase() + result.firstName.substring(1);
            }
            if (result.lastName) {
                result.lastName = result.lastName[0].toUpperCase() + result.lastName.substring(1);
            }
        }
        return result;
    }

    //static formatCurrency(amount, numDP, includeSymbol) {
    //    if (typeof numDP == 'undefined') {
    //        numDP = 2;
    //    }
    //    let result = Number((amount || 0).toFixed(numDP)).toLocaleString();
    //    result = result.replace(/\.00/, '');
    //    result = result.replace(/(\.[1-9]$)/, '$10');
    //    if (includeSymbol) {
    //        result = '£' + result;
    //    }
    //    return result;
    //}

    static roundCurrency(amount, numDP) {
        const exponent = Math.pow(10, numDP);
        return Math.round(Number(amount) * exponent) / exponent; 
    }

    static formatCurrencyNew(amount, opt) {
        opt = { ...opt };
        if (!opt.currency) {
            opt.currency = {
                thousandSeparator: ',',
                decimalSeparator: '.',
                symbol: '£'
            };
        }
        if (typeof opt.commas == 'undefined') {
            opt.commas = true;
        }
        if (typeof opt.includeSymbol == 'undefined') {
            opt.includeSymbol = true;
        }
        if (typeof opt.numDP == 'undefined') {
            opt.numDP = 2;
        }
        if (typeof opt.ifZero != 'undefined' && Number(amount || 0) == 0) {
            return opt.ifZero;
        }
        let result = Number(amount || 0).toFixed(opt.numDP).toLocaleString();
        result = result.replace(/\.00/, '');
        result = result.replace(/(\.[1-9]$)/, '$10');
        if (opt.commas) {
            var parts = result.split('.');
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, opt.currency.thousandSeparator);
            result = parts.join(".");
        }
        if (opt.includeSymbol) {
            result = opt.currency.symbol + result;
        }
        return result;
    }

    static getValues(field, includeEmpty) {
        let values = (includeEmpty ? [''] : []);
        switch ((field || '').toLowerCase()) {
            case 'invoicefrequency':
                values = values.concat(['OnJobComplete', 'Monthly']);
                break;
            case 'paymentterms':
                values = values.concat(['OnReceipt', 'DayOfMonth', 'EndOfNextMonth', 'AfterXDays']);
                break;
            default:
                throw 'Unknown field: ' + field;
        }
        return values;
    }

    static getFriendlyName(value, emptyText) {
        switch ((value || '').toLowerCase()) {
            case '': return emptyText || '';
            
            // Invoice frequency
            case 'onjobcomplete': return 'On job completion';
            case 'monthly': return 'Monthly';

            // Payment terms
            case 'onreceipt': return 'On receipt';
            case 'dayofmonth': return 'Specific day of the month';
            case 'endofnextmonth': return 'End of following month';
            case 'afterxdays': return 'After specific number of days';

            default: return value;
        }
    }

    static formatDuration(mins, interval) {
        if (typeof (interval) == 'undefined') {
            interval = 15;
        }
        const parts = [];
        mins = Math.floor(mins * interval) / interval;
        const hours = Math.floor(mins / 60);
        if (hours > 0) {
            parts.push(hours + 'hr');
            mins -= hours * 60;
        }
        if (mins > 0) {
            parts.push(mins + 'min');
        }
        return parts.join(' ');
    }

    static getNickname(user) {
        const nameParts = [ user.firstName ];
        if (user.lastName) {
            nameParts.push(user.lastName.substring(0, 1).toUpperCase());
        }
        return nameParts.join(' ').trim();
    }

    static buildURL(url, queryString) {
        let isFirstQS = true;
        if (queryString) {
            for (var key in queryString) {
                let value = queryString[key];
                if (value) {
                    url += (isFirstQS ? '?' : '&') + key + '=' + encodeURIComponent(value);
                    isFirstQS = false;
                }
            }
        }
        return url;
    }

    static getDatesSummary(dates, title) {
        if (dates.length == 0) {
            return '';
        }
        dates.sort((a, b) => a.date - b.date);
        return (
            '<p><b>' + title + ':</b></p><ul>' +
            dates.map(d =>
                `<li>${moment(d.date).format('dddd, DD MMMM YYYY')} ${d.isLocked ? '<span class="text-bad">(Requires approval)' : ''}</span></li>`
            ).join('\r\n')
            + '</ul>'
        );
    }

    static getPhoneNumberNumeric(phoneNumber) {
        if (!phoneNumber) return '';

        // Remove all non-numeric characters except +
        phoneNumber = phoneNumber.replace(/[^0-9\+]/g, '');
        // Add default country code
        if (phoneNumber.indexOf('+') == -1) {
            phoneNumber = '44' + phoneNumber;
        }
        // Remove the plus
        phoneNumber = phoneNumber.replace(/\+/g, '');
        // Done
        return phoneNumber;
    }

    static splitIntoLines(text, fn) {
        text = text || '';
        return text.split(/\r\n|\r|\n/).map((line, index) =>
            <React.Fragment key={index}>
                {fn(line, index)}
            </React.Fragment>
        );
    }

    static escapeHTML(str) {
        str = str || '';
        str = str.replace(/</, '&lt;');
        str = str.replace(/>/, '&gt;');
        str = str.replace(/&/, '&amp;');
        return str;
    }

    static formatMaxTravelDistance(distance) {
        if (!distance) {
            return '—';
        }
        else if (distance >= 99999) {
            return 'Any distance';
        }
        else {
            return `${distance}km`;
        }
    }

    static formatMaxDeliveries(maxDeliveries) {
        if (!maxDeliveries) {
            return '—';
        }
        else if (maxDeliveries >= 99999) {
            return 'Unrestricted';
        }
        else {
            return `${maxDeliveries}`;
        }
    }
}

window.TextHelpers = TextHelpers;
